import { initHome } from "./home.js";
import { initHomeShop } from "./home-shop.js";
import { initHomeDialogs } from "./home-dialogs.js";
import { initSmoothScroll } from "./smooth-scroll.js";
import { initHeader } from "./header.js";
import { initOrderCheckout } from "./order.js";
import { initLoading } from "./loading.js";

const loadingReady = initLoading();

jQuery(function ($) {
  // ページ内移動と買い物袋を共通化し、トップの演出は対象ページだけ初期化する
  initSmoothScroll($);
  initHeader($);
  if ($('.js-order-confirm').length) initOrderCheckout($);
  if ($(".js-home-cart-open").length) {
    const dialogs = initHomeDialogs($);
    initHomeShop($, dialogs);
  }
  if ($(".js-home").length) loadingReady.then(function () { initHome($); });
});
